import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useTranslator } from '@jutro/locale';
import messages from '../../MLCreateEditDocumentsPopup.messages';

import { Button } from '@jutro/legacy/components';

function MLDocumentSearchBtns (props) {
    const {
        onSearch,
        onReset,
        className
    } = props;
    const translator = useTranslator();

    return(
        <div className={className}>
            <Button type="outlined" onClick={onSearch}>
                {translator(messages.search)}
            </Button>
            <Button type="outlined" onClick={onReset}>
                {translator(messages.reset)}
            </Button>
        </div>
    )
}

export default MLDocumentSearchBtns;